const REMEMBER_USERNAME = 'ica-username';

export class LocalStorageUtils {
  static getUserName = () => {
    const userName = localStorage.getItem(REMEMBER_USERNAME);
    return userName ? userName : '';
  };

  static setUserName = (userName: string) => {
    localStorage.setItem(REMEMBER_USERNAME, userName);
  };
}
